import { FlightCore } from 'types';

export namespace SkyscannerResults {

  export enum PollingState {
    UpdatesPending = 'UpdatesPending',
    UpdatesComplete = 'UpdatesComplete',
  }

  export interface Session {
    sessionToken: string;
  }
  
  export interface Poll {
    Status: PollingState;
    SessionKey: string;
    Query: Query;
    Itineraries: Itinerary[];
    Legs: Leg[];
    Segments: Segment[];
    Carriers: Carrier[];
    Agents: Agent[];
    Places: Place[];
    Currencies: Currency[];
  } 

  export interface Query {
    Country: string;
    Currency: string;
    Locale: string;
    Adults: number;
    Children: number;
    Infants: number;
    OriginPlace: string;
    DestinationPlace: string;
    OutboundDate: string;
    InboundDate: string;
    LocationSchema: string;
    CabinClass: string;
    GroupPricing: boolean;
  }

  export interface Itinerary {
    OutboundLegId: string;
    InboundLegId?: string;
    PricingOptions: PricingOption[];
  }

  export interface PricingOption {
    Agents: number[];
    QuoteAgeInMinutes: number;
    Price: number;
    DeeplinkUrl: string;
    BookingDetailsLink: BookingDetailsLink;
  }

  interface BookingDetailsLink {
    Uri: string;
    Body: string;
    Method: string;
  }

  export interface Leg {
    Id: string;
    SegmentIds: number[];
    OriginStation: number;
    DestinationStation: number;
    Departure: string;
    Arrival: string;
    Duration: number;
    JourneyMode: string;
    Stops: number[];
    Carriers: number[];
    OperatingCarriers: number[];
    Directionality: FlightCore.Directionality;
    FlightNumbers: FlightNumber[];
  }

  export interface FlightNumber {
    FlightNumber: string;
    CarrierId: number;
  }

  export interface Segment {
    Id: number;
    OriginStation: number;
    DestinationStation: number;
    DepartureDateTime: string;
    ArrivalDateTime: string;
    Carrier: number;
    OperatingCarrier: number;
    Duration: number;
    FlightNumber: string;
    JourneyMode: string;
    Directionality: FlightCore.Directionality;
  }

  export interface Carrier {
    Id: number;
    Code: string;
    Name: string;
    ImageUrl: string;
    DisplayCode: string;
  }

  export interface Agent {
    Id: number;
    Name: string;
    ImageUrl: string;
    Status: PollingState;
    OptimisedForMobile: boolean;
    BookingNumber: string;
    Type: string;
  }

  export interface Place {
    Id: number;
    ParentId?: number;
    Code: string;
    Type: string;
    Name: string;
  }

  export interface Currency {
    Code: string;
    Symbol: string;
    ThousandsSeparator: string;
    DecimalSeparator: string;
    SymbolOnLeft: string;
    SpaceBetweenAmountAndSymbol: boolean;
    RoundingCoefficient: number;
    DecimalDigits: number;
  }

  export interface BrowseRoutes {
    data: {
      Quotes: Quotes[],
    }
  }
  
  export interface Quotes {
    MinPrice: number;
  }
} 